<div class="switch-button">
  <p>{{ translationKey | translate }}</p>
  <label class="switch">
    <input type="checkbox" [checked]="checked"/>
    <small></small>
  </label>
</div>
